(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DettaglioOrdineDBSearch', DettaglioOrdineDBSearch);

    DettaglioOrdineDBSearch.$inject = ['$resource'];

    function DettaglioOrdineDBSearch($resource) {
        var resourceUrl =  'api/_dbsearch/dettaglio-ordines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
